<template>
  <li>
    <!-- self -->
    <div class="label_area">
      <span class="toggle_btn" v-if="hasChild" @click="toggleOpen">
        <i :class="open ? 'bx bxs-down-arrow' : 'bx bxs-right-arrow'"></i>
      </span>
      <span class="space_name" @click="toggleDetail">{{ objectType }}[{{ (objectData && objectData.umCode) ? objectData.umCode : 'なし' }},{{ (objectData && objectData.objName) ? objectData.objName : 'なし' }}]</span>
      <span class="close_button" @click="toggleDetail" v-if="detail">
        <i class="bx bx-x-circle"></i>
      </span>
    </div>
    <div class="detail_area" v-if="detail">
      <div>
        <h4>空間データ</h4>
        <ul>
          <li>{{ spaceData }}</li>
        </ul>
      </div>
      <div>
        <h4>面関連</h4>
        <ul>
          <li v-for="fr in faceRelationList" :key="fr.frId">{{ fr }}</li>
          <li v-if="!faceRelationList.length">なし</li>
        </ul>
      </div>
      <div>
        <h4>オブジェクトデータ</h4>
        <ul>
          <li>{{ objectData }}</li>
          <li v-if="!objectData">なし</li>
        </ul>
      </div>
      <div>
        <h4>アトリビュート</h4>
        <ul>
          <li v-for="att in attributeList" :key="att.attId">{{ att }}</li>
          <li v-if="!attributeList.length">なし</li>
        </ul>
      </div>
      <div>
        <h4>加工データ</h4>
        <ul>
          <li v-for="pd in processList" :key="pd.pdId">{{ pd }}</li>
          <li v-if="!processList.length">なし</li>
        </ul>
      </div>
    </div>
    <!-- children -->
    <ul v-if="hasChild && open">
      <dd-com-space-tree-item
        v-for="child in space.childrenSpaceModel"
        v-if="isActive(child)"
        :key="'space-tree-' + child.id"
        :fileData="fileData"
        :space="child"
      />
    </ul>
  </li>
</template>

<script>
import {OBJECT_TYPE} from '../../constants/Type'

export default {
  name: 'dd-com-space-tree-item',
  components: {
  },
  props: {
    fileData: Object,
    space: Object
  },
  data: function () {
    return {
      open: false,
      detail: false
    }
  },
  computed: {
    hasChild: function () {
      if (!this.space || this.space.length === 0) return ''
      return this.space.childrenSpaceModel && this.space.childrenSpaceModel.length
    },
    spaceData: function () {
      // 元データを変更しないようクローンして、子空間リストを消込み
      let copy = Object.assign({}, this.space)
      if (copy.childrenSpaceModel !== null) {
        delete copy.childrenSpaceModel
      }
      return copy
    },
    objectType: function () {
      if (!this.space || this.space.length === 0) return ''
      return Object.keys(OBJECT_TYPE)
        .map(e => OBJECT_TYPE[e])
        .find(e => e.code === this.space.spaceObjectType)
        .label
    },
    faceRelationList: function () {
      if (!this.space || this.space.length === 0) return ''
      return this.fileData.faceRelationModelList.filter(e => e.frFace1SpaceId === this.space.id)
    },
    objectData: function () {
      if (!this.space || this.space.length === 0) return ''
      return this.fileData.objectDataModelList.find(e => e.spaceId === this.space.id)
    },
    attributeList: function () {
      if (!this.space || this.space.length === 0) return ''
      return this.fileData.attributeModelList.filter(e => e.spaceId === this.space.id)
    },
    processList: function () {
      if (!this.space || this.space.length === 0) return ''
      return this.fileData.processFixList.filter(e => e.pdOwnSpId === this.space.id)
    }
  },
  methods: {
    /** 開閉切替え */
    toggleOpen: function () {
      if (this.hasChild) {
        this.open = !this.open
      }
    },
    /** 詳細表示切替え */
    toggleDetail: function () {
      this.detail = !this.detail
      // this.treeStatusMap[this.space.id].detail = this.detail
      // AppUtil.addLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
    },
    /** 表示対象として有効な空間か */
    isActive: function (space) {
      // オブジェクトデータによるフィルタリング
      if (this.fileData.objectDataModelList && this.fileData.objectDataModelList.length) {
        let objectData = this.fileData.objectDataModelList.find(obj => obj.spaceId === space.id)
        if (objectData && (objectData.objEnableFlag === 0 || objectData.objDrawFlag === 0)) return false
      }
      return true
    }
  },
  mounted: function () {
    // if (this.treeStatusMap && this.treeStatusMap[this.space.id]) {
    //   this.open = this.treeStatusMap[this.space.id].open
    //   this.detail = this.treeStatusMap[this.space.id].detail
    // }
  }
}
</script>
<style lang="scss" scoped>
.toggle_btn:hover, .space_name:hover, .close_button:hover {
  color: #ff4500;
  cursor: pointer;
}
.close_button i {
  vertical-align: middle;
}
.label_area {
  white-space: nowrap;
}
.detail_area {
  padding: 5px;
  margin: 7px 2px;
  box-shadow: 0 0 1.5px rgba(102, 102, 102, 0.7);
  display: inline-block;
  ul {
    margin: 0 5px;
  }
}
ul {
  margin-left: 15px;
}
h4 {
  margin: 5px 0;
  padding: 3px;
  border-bottom: 1px solid #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/ComSpaceTreeItem.vue